<template>
  <footer class="main-layout__footer">© BTG Pactual. Todos los derechos reservados.</footer>
</template>

<script setup></script>

<style lang="scss" scoped>
.main-layout__footer {
  background-color: var(--primary-extended-90);
  color: var(--neutral-emphasis-inverse-on-neutral-inverse-high, #fff);
  text-align: center;
  font-size: 12px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;

  /* Móvil: el footer entra en el flujo para no tapar contenido al hacer scroll */
  @media screen and (max-width: 1023px) {
    position: static;
  }
}
</style>
